import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'

import { SearchContext } from './search-context';
const Link = loadable(() => import('../../ui/components/link'));

/**
A component for clearing all filter options
@examples
```jsx
<SearchClearFilter
    watchFields={/(facets.*|price|rating)/}
/>
```
@component SearchClearFilter
@import SearchClearFilter
@example ../docs/SearchClearFilter.md
@returns {ReactElement} The rendered component
*/
export default class SearchClearFilter extends React.Component {
    static defaultProps = {
        className: '',
        autoHide: false,
        watchFields: new RegExp()
    }

    static propTypes = {
        autoHide: PropTypes.bool,
        /**
         * Optional regex patter for facet slections that should be cleared
         */
        watchFields: PropTypes.object
    }

    clearFilters = (query, setQuery) => {
        const { watchFields, onClick } = this.props;
        return () => {
            //if watchFields pass only clear those fields from query
            let newQuery = watchFields
                ? Object.keys(query).reduce((r, key) => {
                      if (!key.match(watchFields)) {
                          r[key] = query[key];
                      }
                      return r;
                  }, {})
                : query;
            setQuery(newQuery);
            onClick && onClick();
        };
    };

    render() {
        const { className, autoHide, watchFields, isV2 } = this.props;
        return (
            <SearchContext.Consumer>
                {({ query, setQuery }) => {
                    if (
                        watchFields &&
                        Object.keys(query).filter(key => key.match(watchFields)).length === 0 &&
                        autoHide
                    ) {
                        return null;
                    }
                    return !isV2 ? (
                        <button
                            type="button"
                            aria-label="Clear All"
                            className={'clear-filters unstyled ' + className}
                            onClick={this.clearFilters(query, setQuery)}
                        >
                            {this.props.children || 'Clear all'}
                        </button>
                    ) : (<Link 
                            aria-label="Clear All" 
                            onClick={this.clearFilters(query, setQuery)}
                            size={'small'}
                            className={'clear-filters unstyled ' + className}>{this.props.children || 'Clear all'}</Link>);
                }}
            </SearchContext.Consumer>
        );
    }
}

